var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container b-card",staticStyle:{"height":"90vh"}},[_c('iframe',{attrs:{"src":_vm.file_source,"width":"100%","height":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }